var _defs, _g, _g2, _g3, _g4, _g5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSituationSafePlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 7500 1888.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-47,.cls-6{fill:none;}.cls-2{fill:#5b5b5b;}.cls-3{fill:#aaa;}.cls-4{fill:#323639;}.cls-5{fill:#997d6e;}.cls-6{stroke:#67727e;stroke-width:4px;}.cls-47,.cls-6{stroke-miterlimit:10;}.cls-7{fill:#b4bfbe;}.cls-8{fill:#474949;}.cls-9{fill:#575b31;}.cls-10{fill:#7a9239;}.cls-11{fill:#999;}.cls-12{fill:#ccc;}.cls-13{opacity:0.24;fill:url(#D\xE9grad\xE9_sans_nom_51);}.cls-14{fill:#727272;}.cls-15{clip-path:url(#clip-path);}.cls-16{fill:#515151;}.cls-17{fill:#353535;}.cls-18{fill:#969696;}.cls-19{fill:#f7f7f7;}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_13);}.cls-21{fill:url(#D\xE9grad\xE9_sans_nom_13-2);}.cls-22{fill:url(#D\xE9grad\xE9_sans_nom_13-3);}.cls-23{fill:url(#D\xE9grad\xE9_sans_nom_13-4);}.cls-24{fill:url(#D\xE9grad\xE9_sans_nom_13-5);}.cls-25{fill:url(#D\xE9grad\xE9_sans_nom_13-6);}.cls-26{fill:url(#D\xE9grad\xE9_sans_nom_13-7);}.cls-27{fill:url(#D\xE9grad\xE9_sans_nom_10);}.cls-28{clip-path:url(#clip-path-2);}.cls-29{fill:#dbdbdb;}.cls-30{fill:url(#D\xE9grad\xE9_sans_nom_27);}.cls-31{fill:url(#D\xE9grad\xE9_sans_nom_27-2);}.cls-32{fill:#333;}.cls-33{fill:#f7f6f5;}.cls-34{fill:#878787;opacity:0.46;}.cls-35{fill:#f0ebe8;}.cls-36{fill:#7c7c7c;}.cls-37{fill:#565656;}.cls-38{fill:#606060;}.cls-39{fill:#0e5177;}.cls-40{fill:#0170b8;}.cls-41{fill:#ededed;}.cls-42{fill:#cccdce;}.cls-43{fill:url(#D\xE9grad\xE9_sans_nom_8);}.cls-44{fill:#d48445;}.cls-45{fill:#3a1809;}.cls-46{fill:#ecc09b;}.cls-47{stroke:#1e0200;opacity:0.68;}.cls-48{fill:url(#D\xE9grad\xE9_sans_nom_8-2);}.cls-49{clip-path:url(#clip-path-3);}.cls-50{fill:#221216;}.cls-50,.cls-62,.cls-63,.cls-64,.cls-65,.cls-66,.cls-73,.cls-84,.cls-85,.cls-88{opacity:0.38;}.cls-51,.cls-56,.cls-59,.cls-68,.cls-69,.cls-71,.cls-78,.cls-83,.cls-86,.cls-87{opacity:0.13;}.cls-51{fill:url(#D\xE9grad\xE9_sans_nom_6);}.cls-52,.cls-53{fill:#c59370;}.cls-53{opacity:0.54;}.cls-54{fill:url(#D\xE9grad\xE9_sans_nom_8-3);}.cls-55{clip-path:url(#clip-path-4);}.cls-56{fill:url(#D\xE9grad\xE9_sans_nom_6-2);}.cls-57{fill:url(#D\xE9grad\xE9_sans_nom_8-4);}.cls-58{clip-path:url(#clip-path-5);}.cls-59{fill:url(#D\xE9grad\xE9_sans_nom_6-3);}.cls-60{fill:url(#D\xE9grad\xE9_sans_nom_8-5);}.cls-61{fill:#ad7955;}.cls-62{fill:#300f00;}.cls-63{fill:#2e1203;}.cls-64{fill:#1e0500;}.cls-65{fill:#613e1e;}.cls-66,.cls-67{fill:#b99471;}.cls-68{fill:url(#D\xE9grad\xE9_sans_nom_6-4);}.cls-69{fill:url(#D\xE9grad\xE9_sans_nom_6-5);}.cls-70{fill:url(#D\xE9grad\xE9_sans_nom_8-6);}.cls-71{fill:url(#D\xE9grad\xE9_sans_nom_6-6);}.cls-72{fill:url(#D\xE9grad\xE9_sans_nom_8-7);}.cls-73{fill:#39251f;}.cls-74{fill:url(#D\xE9grad\xE9_sans_nom_8-8);}.cls-75{fill:url(#D\xE9grad\xE9_sans_nom_8-9);}.cls-76{fill:url(#D\xE9grad\xE9_sans_nom_8-10);}.cls-77{clip-path:url(#clip-path-6);}.cls-78{fill:url(#D\xE9grad\xE9_sans_nom_6-7);}.cls-79{fill:#dba57b;}.cls-80{fill:#8e6042;}.cls-81{fill:#edc9a5;}.cls-82{fill:#723421;}.cls-83{fill:url(#D\xE9grad\xE9_sans_nom_6-8);}.cls-84{fill:#541e05;}.cls-85{fill:#371108;}.cls-86{fill:url(#D\xE9grad\xE9_sans_nom_6-9);}.cls-87{fill:url(#D\xE9grad\xE9_sans_nom_6-10);}.cls-88{fill:#60534a;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_51",
    x1: 3731.43,
    y1: 1831,
    x2: 3780.72,
    y2: 419.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c9eeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c90e0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "3749.46 2124 3738 2118 3738 2105 3749.46 2100 3749.46 2043 3738 2039 3738 2024 3749.46 2019 3749.46 1961 3738 1956 3738 1942 3749.46 1937 3749.46 1871 3738 1866 3738 1852 3749.46 1847 3749.46 1790 3738 1785 3738 1771 3749.46 1766 3749.46 1684.23 3798.05 1683.66 3800 732 3749.46 731.59 3738 727 3738 712.17 3749.46 707 3749.46 649 3738 644.06 3738 630 3749.46 625 3749.46 531 3738 527 3738 513 3749.46 507 3749.46 450 3738 446 3738 431 3749.46 426 3749.46 368 3738 362.9 3738 349 3749.46 344 3749.46 271.3 7500 271.3 7500 2124 3749.46 2124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13",
    x1: 3513.57,
    y1: 1111.78,
    x2: 3513.57,
    y2: 1017.57,
    gradientTransform: "translate(2192.76 4788.96) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f59604"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df360f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-2",
    x1: 3516.05,
    y1: 1004.56,
    x2: 3516.05,
    y2: 971.09,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-3",
    x1: 3559.43,
    y1: 1113.51,
    x2: 3559.43,
    y2: 1017.74,
    gradientTransform: "translate(2192.76 5060.26) rotate(-90)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-4",
    x1: 3630.71,
    y1: 1111.78,
    x2: 3630.71,
    y2: 1020.05,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-5",
    x1: 3766,
    y1: 1111.78,
    x2: 3766,
    y2: 1020.05,
    gradientTransform: "translate(2192.76 5060.26) rotate(-90)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-6",
    x1: 3842.05,
    y1: 1111.89,
    x2: 3842.05,
    y2: 1020.05,
    gradientTransform: "translate(2192.76 5060.26) rotate(-90)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_13-7",
    x1: 3694.97,
    y1: 1111.78,
    x2: 3694.97,
    y2: 1020.05,
    gradientTransform: "translate(2192.76 5060.26) rotate(-90)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_10",
    x1: 3799.92,
    y1: 1175,
    x2: 3799.92,
    y2: 985.44,
    gradientTransform: "translate(2192.76 5060.26) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1d212"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#019944"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3478,2062h-24l-4-1100.29c1.19,0,1.18-2.5,0-2.49V957h-2v-4l-357-12v-9l358,9v-8h14l.35,26.22c-1.16,0-1.13,2.51,0,2.49Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_27",
    x1: 3449.07,
    y1: 1225.82,
    x2: 3473.07,
    y2: 1225.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b8b8b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8b8b8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_27-2",
    x1: 3267.57,
    y1: 676.01,
    x2: 3268.01,
    y2: 663.38,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_27"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8",
    x1: 4776.89,
    y1: 1568.34,
    x2: 4776.89,
    y2: 1421.51,
    gradientTransform: "matrix(-1, 0, 0, 1, 10543.78, -271.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d48445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-2",
    x1: 3189.39,
    y1: 1569.83,
    x2: 3189.39,
    y2: 1423,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5617.21,1513.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6H5436v10.69l-132,.43,2,216,25,25.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6",
    x1: 3800.6,
    y1: 1301,
    x2: 3800.6,
    y2: 1260.88,
    gradientTransform: "matrix(-1, 0, 0, 1, 9255.1, -271.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edc19d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2319"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-3",
    x1: 2041.39,
    y1: 1565.83,
    x2: 2041.39,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6765.21,1509.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6H6584v10.69l-132,.43,2,216,25,25.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-2",
    x1: 2652.6,
    y1: 1297,
    x2: 2652.6,
    y2: 1256.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-4",
    x1: 1394.9,
    y1: 1565.83,
    x2: 1394.9,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M7413.21,1509.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6H7232v10.69l-132,.43-18,60,20,156,25,25.12Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-3",
    x1: 2004.6,
    y1: 1297,
    x2: 2004.6,
    y2: 1256.88,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-5",
    x1: 3496.77,
    y1: 1565.83,
    x2: 3496.77,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-4",
    x1: 4002.89,
    y1: 1154.9,
    x2: 4002.89,
    y2: 1133.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 8977.12, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-5",
    x1: 3749.34,
    y1: 1161.87,
    x2: 3749.34,
    y2: 1133.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 8977.12, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-6",
    x1: 2356.28,
    y1: 1565.83,
    x2: 2356.28,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-6",
    x1: 2614.34,
    y1: 1161.87,
    x2: 2614.34,
    y2: 1133.62,
    gradientTransform: "matrix(-1, 0, 0, 1, 8977.12, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-7",
    x1: 3795.97,
    y1: 1565.12,
    x2: 3795.97,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-8",
    x1: 1718.97,
    y1: 1565.12,
    x2: 1718.97,
    y2: 1419,
    gradientTransform: "matrix(-1, 0, 0, 1, 8643.78, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-9",
    x1: 4194.89,
    y1: 1294.04,
    x2: 4194.89,
    y2: 1147.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_8-10",
    x1: 4490.1,
    y1: 1294.7,
    x2: 4490.1,
    y2: 1152.7,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_8"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6",
    transform: "translate(0 -271.3)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4348.89,1509.12l-1.84-67.63,14.71-22.75v-3a4,4,0,0,0,0-2.29v-66a2.53,2.53,0,0,0,0-2.82v-64.1l23.45-23.6H4508v10.69h125.07l2,26.55v215Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-7",
    x1: 4493.3,
    y1: 1028.59,
    x2: 4493.3,
    y2: 985.58,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-8",
    x1: 4184.56,
    y1: 1096.53,
    x2: 4184.56,
    y2: 1077.98,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-9",
    x1: 4129.83,
    y1: 1161.23,
    x2: 4129.83,
    y2: 1133.71,
    gradientTransform: "matrix(-1, 0, 0, 1, 8977.12, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_6-10",
    x1: 4024.42,
    y1: 1093.04,
    x2: 4024.42,
    y2: 1087.95,
    gradientTransform: "matrix(-1, 0, 0, 1, 8977.12, -271.3)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_6"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Fond d&amp;apos;\xE9cran") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_6",
    "data-name": "Calque 6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "0 1644.7 0 1521.7 3750 1493.7 3750 1627.7 0 1644.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "0 897.7 79 916.33 79 1444.7 0 1443.7 0 897.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "79 637.7 1775 637.7 1775 1431.73 79 1444.7 79 637.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "1775 1438.73 1775 401.7 3270 401.7 3263 1437.7 1775 1437.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rembarde"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 152.49,
    y1: 637.7,
    x2: 185,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 195.55,
    y1: 637.7,
    x2: 219,
    y2: 589.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 237.08,
    y1: 637.7,
    x2: 246,
    y2: 613.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 343.61,
    y1: 637.7,
    x2: 344,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 490.37,
    y1: 637.7,
    x2: 490,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 632.05,
    y1: 637.7,
    x2: 632,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 781,
    y1: 637.7,
    x2: 781,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 927,
    y1: 637.7,
    x2: 927,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1073.8,
    y1: 637.7,
    x2: 1074,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1219.11,
    y1: 637.7,
    x2: 1219,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1364.43,
    y1: 637.7,
    x2: 1364,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1514.1,
    y1: 637.7,
    x2: 1514,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 1658,
    y1: 637.7,
    x2: 1657.9,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "1775 613.7 152 613.7 185 637.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "270.37 637.7 169 567.7 1774.96 567.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "185 1443.89 185 736.7 1774.96 727.49 1775 1437.7 185 1443.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 263,
    y: 906.7,
    width: 1429,
    height: 195
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "1692 1437.7 276 1443.7 276 1240.7 1692 1240.7 1692 1437.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "0 1773.7 3750 1773.7 3750 1617.7 0 1635.7 0 1773.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "0 1700.23 3752 1700.7 3756 1617.7 0 1635.7 0 1700.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "0 1557.7 3752 1534.7 3751 1429.7 0 1444.7 0 1557.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "0.1 1545.31 3753.28 1521.37 3752 1539.7 0 1557.73 0.1 1545.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "0 1549.7 3749.07 1528.87 3754.09 1521.67 0 1544.7 0 1549.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 932,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "3227 1437.7 1811 1443.7 1811 1240.7 3227 1240.7 3227 1437.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "3263 637.7 4959 637.7 4959 1431.73 3263 1444.7 3263 637.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rembarde-2",
    "data-name": "rembarde"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4891.51,
    y1: 637.7,
    x2: 4859,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4848.45,
    y1: 637.7,
    x2: 4825,
    y2: 589.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4806.92,
    y1: 637.7,
    x2: 4798,
    y2: 613.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4700.39,
    y1: 637.7,
    x2: 4700,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4553.63,
    y1: 637.7,
    x2: 4554,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4411.95,
    y1: 637.7,
    x2: 4412,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4263,
    y1: 637.7,
    x2: 4263,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 4117,
    y1: 637.7,
    x2: 4117,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3970.2,
    y1: 637.7,
    x2: 3970,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3824.89,
    y1: 637.7,
    x2: 3825,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3679.57,
    y1: 637.7,
    x2: 3680,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3529.9,
    y1: 637.7,
    x2: 3530,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 3386,
    y1: 637.7,
    x2: 3386.1,
    y2: 562.7
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "3269 613.7 4892 613.7 4859 637.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-6",
    points: "4773.63 637.7 4875 567.7 3269.04 567.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3369 1443.89 3369 736.7 4958.96 727.49 4959 1437.7 3369 1443.89"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3447,
    y: 906.7,
    width: 1429,
    height: 195
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "4876 1437.7 3460 1443.7 3460 1240.7 4876 1240.7 4876 1437.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fen\\xEAtres"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "602 1442.7 286 1443.7 286 1251.7 602 1251.7 602 1442.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 660,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 751,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 842,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1023,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1114,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1204,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1295,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1823,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 1927.9,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2032.81,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2136.56,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2241.46,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2346.36,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2450.11,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2555.01,
    y: 1247.7,
    width: 97.99,
    height: 119
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "3786 1442.7 3470 1443.7 3470 1251.7 3786 1251.7 3786 1442.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3844,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 3935,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4026,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4116,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4207,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4298,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4388,
    y: 1247.7,
    width: 85,
    height: 119
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 4479,
    y: 1247.7,
    width: 85,
    height: 119
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 1812,
    y: 546.7,
    width: 980,
    height: 612
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2955,
    y: 548.7,
    width: 161,
    height: 272
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2955,
    y: 885.7,
    width: 161,
    height: 272
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "pers_atmosph\\xE9riqu",
    "data-name": "pers atmosph\\xE9riqu",
    className: "cls-13",
    points: "3268 637.7 3270 401.7 1775 401.7 1775 637.7 79 637.7 79 915.7 0 897.7 0 1700.7 7500 1700.7 3751 637.7 3268 637.7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Fond"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    y: 1773.26,
    width: 7500,
    height: 115.35
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "7500 1888.7 3749.46 1888.7 3749.46 1852.7 3738 1846.7 3738 1833.7 3749.46 1828.7 3749.46 1771.7 3738 1767.7 3738 1752.7 3749.46 1747.7 3749.46 1689.7 3738 1684.7 3738 1670.7 3749.46 1665.7 3749.46 1599.7 3738 1594.7 3738 1580.7 3749.46 1575.7 3749.46 1518.7 3738 1513.7 3738 1499.7 3749.46 1494.7 3749.46 1412.93 3798.05 1412.36 3800 460.7 3749.46 460.29 3738 455.7 3738 440.87 3749.46 435.7 3749.46 377.7 3738 372.76 3738 358.7 3749.46 353.7 3749.46 259.7 3738 255.7 3738 241.7 3749.46 235.7 3749.46 178.7 3738 174.7 3738 159.7 3749.46 154.7 3749.46 96.7 3738 91.6 3738 77.7 3749.46 72.7 3749.46 0 7500 0 7500 1888.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 20.7,
    width: 3782,
    height: 17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 72.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 72.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 154.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 154.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 235.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 235.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 353.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 353.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 435.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 435.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 516.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 516.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1412.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1412.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1494.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1494.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1575.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1575.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1665.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1665.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1747.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1747.7,
    width: 3782,
    height: 5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 3718,
    y: 1828.7,
    width: 3782,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 3718,
    y: 1828.7,
    width: 3782,
    height: 5
  })), /*#__PURE__*/React.createElement("g", {
    id: "drapeau_iserba",
    "data-name": "drapeau iserba"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-19",
    points: "3101.84 670.06 3102 1407.7 3437 1407.7 3437 680.95 3101.84 670.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "3210.33 1294.61 3304.54 1294.61 3302.06 1287.17 3210.33 1256.18 3210.33 1294.61"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 3180.58,
    cy: 1272.91,
    r: 16.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M3235.13,1475.42l-18.6-12.4c-13.69,35-3.14,54,22.31,63.22,14,4.31,24.46-2.82,29.75-26,6.2-16.12,34.71,0,8.68,23.55l19.83,14.88c10.54-19.77,13.81-39.87,0-60.74-24.52-16.41-42.14-14.88-50.82,12.39C3240.08,1512.61,3222.73,1499,3235.13,1475.42Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "3304.54 1191.72 3212.81 1176.85 3212.81 1124.79 3232.14 1127.92 3232.65 1154.53 3247.52 1157.01 3247.52 1132.22 3268.59 1134.7 3268.59 1160.73 3283.47 1164.45 3284.47 1136.4 3304.54 1139.66 3304.54 1191.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M3255,1269.65c-9.92-12.4-40.52-16.65-42.15,7.44V1318l91.73,13.64-1.24-40.91C3307,1259.73,3266.05,1244.21,3255,1269.65Zm-22.31,27.27c-7.69-16.33,8.67-17.36,14.37-10.38.5,4.18,1.74,9.14,1.74,12.86Zm53.3-6.2v14.88l-19.84-5,1.24-14.88C3272.31,1277.09,3284.71,1280.8,3286,1290.72Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M3212.81,1190.32l1.24,26,90.49,49.58V1246.1c.42-3.54-.42-5.59-2.48-6.2l-13.63-7.44V1199l12.39-2.48c3-.76,3.72-2.48,3.72-5v-21.08Zm57,32.22-28.51-14.87,28.51-5Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M3212.81,1346.5v44.63l91.73,13.63v-22.31l-33.47-8.68,28.51-12.39c3.37-2,4.76-4.56,5-7.44v-22.31h-6.2l-31,17.35C3256.2,1319.23,3214.11,1317.87,3212.81,1346.5Zm40.91,26-22.31-2.48v-8.67C3232.65,1345.26,3253.72,1350.22,3253.72,1372.53Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M3318.18,1057.68c-24.79-90.49-97.93-100.4-128.92,17.36-13.05,69.44-13.19,135.31-7.44,199.57,0,0,31-205.77,81.82-208.25,18.59-1.24,27.72,14.24,35.94,38.42,42.15,124,68.18,427.66,68.18,427.66C3366.41,1341.13,3354.16,1173.55,3318.18,1057.68Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3180.58,1625.41V1613c9.36,0,15.47,4.48,17.36,14.88-1.45,10.23-7.11,15.73-17.36,16.11,0,0-16.11,0-16.11-16.11,0-12.4,7.44-12.4,7.44-12.4v3.72c-2.37,1.76-3.66,4.59-3.72,8.68,0,0,0,12.39,12.39,12.39s12.4-12.39,12.4-12.39c-.38-6.53-3.72-9.92-8.68-9.92v7.44Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3183.06,1580.78s0-7.44-8.67-7.44-9.92,3.72-9.92,8.68v9.92h32.23v-5h-13.64l13.64-9.92v-6.19Zm-13.63,6.2v-6.2c0-4,9.91-4,9.91,0v6.2Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3164.47,1516.32v-5h22.31c8.37,0,8.37-13.64,0-13.64h-22.31v-5H3188c13.12.69,11.88,24.24-1.24,23.55Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3164.47,1453.11v12.39h32.23v-5h-13.64v-7.43C3183.06,1445.31,3164.47,1445.31,3164.47,1453.11Zm14.87,1.24v6.19h-9.91v-6.19C3169.43,1450.69,3179.34,1450.69,3179.34,1454.35Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3164.47 1152.06 3196.7 1152.06 3196.7 1134.7 3191.74 1134.7 3191.74 1147.1 3181.82 1147.1 3181.82 1134.7 3176.86 1134.7 3176.86 1147.1 3169.43 1147.1 3169.43 1134.7 3164.47 1134.7 3164.47 1152.06"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M3478,2062h-24l-4-1100.29c1.19,0,1.18-2.5,0-2.49V957h-2v-4l-357-12v-9l358,9v-8h14l.35,26.22c-1.16,0-1.13,2.51,0,2.49Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "3454 1790.7 3478 1790.7 3463 660.7 3448 660.7 3454 1790.7"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-31",
    points: "3448 681.7 3445.41 681.61 3087 669.7 3087 657.7 3449 669.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "3450 685.7 3465 685.7 3465 692.7 3446 692.7 3450 685.7"
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3177.4,
    y: 2102.54,
    width: 24,
    height: 4,
    transform: "translate(-4.04 -265.16) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3193.38,
    y: 2090.51,
    width: 24,
    height: 4,
    transform: "translate(-4.02 -265.13) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3209.36,
    y: 2078.48,
    width: 24,
    height: 4,
    transform: "translate(-3.99 -265.1) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3225.33,
    y: 2066.45,
    width: 24,
    height: 4,
    transform: "translate(-3.97 -265.07) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3241.31,
    y: 2054.41,
    width: 24,
    height: 4,
    transform: "translate(-3.95 -265.04) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3257.29,
    y: 2042.38,
    width: 24,
    height: 4,
    transform: "translate(-3.92 -265.01) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3273.27,
    y: 2030.35,
    width: 24,
    height: 4,
    transform: "translate(-3.9 -264.98) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3289.24,
    y: 2018.32,
    width: 24,
    height: 4,
    transform: "translate(-3.88 -264.95) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3305.22,
    y: 2006.29,
    width: 24,
    height: 4,
    transform: "translate(-3.85 -264.92) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3321.2,
    y: 1994.26,
    width: 24,
    height: 4,
    transform: "translate(-3.83 -264.89) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3337.17,
    y: 1982.23,
    width: 24,
    height: 4,
    transform: "translate(-3.81 -264.86) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3353.15,
    y: 1970.2,
    width: 24,
    height: 4,
    transform: "translate(-3.79 -264.83) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3369.13,
    y: 1958.17,
    width: 24,
    height: 4,
    transform: "translate(-3.76 -264.8) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3385.1,
    y: 1946.14,
    width: 24,
    height: 4,
    transform: "translate(-3.74 -264.77) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3401.08,
    y: 1934.11,
    width: 24,
    height: 4,
    transform: "translate(-3.72 -264.74) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3417.06,
    y: 1922.08,
    width: 24,
    height: 4,
    transform: "translate(-3.69 -264.7) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3433.03,
    y: 1910.05,
    width: 24,
    height: 4,
    transform: "translate(-3.67 -264.67) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3449.01,
    y: 1898.02,
    width: 24,
    height: 4,
    transform: "translate(-3.65 -264.64) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3464.99,
    y: 1885.98,
    width: 24,
    height: 4,
    transform: "translate(-3.62 -264.61) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3480.97,
    y: 1873.95,
    width: 24,
    height: 4,
    transform: "translate(-3.6 -264.58) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3496.94,
    y: 1861.92,
    width: 24,
    height: 4,
    transform: "translate(-3.58 -264.55) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3512.92,
    y: 1849.89,
    width: 24,
    height: 4,
    transform: "translate(-3.55 -264.52) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3528.9,
    y: 1837.86,
    width: 24,
    height: 4,
    transform: "translate(-3.53 -264.49) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3544.87,
    y: 1825.83,
    width: 24,
    height: 4,
    transform: "translate(-3.51 -264.46) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3560.85,
    y: 1813.8,
    width: 24,
    height: 4,
    transform: "translate(-3.48 -264.43) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3576.83,
    y: 1801.77,
    width: 24,
    height: 4,
    transform: "translate(-3.46 -264.4) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3592.8,
    y: 1789.74,
    width: 24,
    height: 4,
    transform: "translate(-3.44 -264.37) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3608.78,
    y: 1777.71,
    width: 24,
    height: 4,
    transform: "translate(-3.41 -264.34) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3624.76,
    y: 1765.68,
    width: 24,
    height: 4,
    transform: "translate(-3.39 -264.31) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3640.73,
    y: 1753.65,
    width: 24,
    height: 4,
    transform: "translate(-3.37 -264.27) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3656.71,
    y: 1741.62,
    width: 24,
    height: 4,
    transform: "translate(-3.35 -264.24) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3672.69,
    y: 1729.59,
    width: 24,
    height: 4,
    transform: "translate(-3.32 -264.21) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3688.67,
    y: 1717.55,
    width: 24,
    height: 4,
    transform: "translate(-3.3 -264.18) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3704.64,
    y: 1705.52,
    width: 24,
    height: 4,
    transform: "translate(-3.28 -264.15) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3720.62,
    y: 1693.49,
    width: 24,
    height: 4,
    transform: "translate(-3.25 -264.12) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 3736.6,
    y: 1681.46,
    width: 24,
    height: 4,
    transform: "translate(-3.23 -264.09) rotate(-0.11)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "3165.47 1856.73 3196.16 1856.73 3749.46 1441.79 3749.46 1416.31 3165.47 1856.73"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "sol_blanc_int\\xE9rieur",
    "data-name": "sol blanc int\\xE9rieur",
    className: "cls-33",
    x: 3780.01,
    y: 1188.8,
    width: 3719.99,
    height: 223.56
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "ombres_caissons",
    "data-name": "ombres caissons",
    className: "cls-34",
    points: "4003 1293.7 5670 1297.7 5670 1188.8 4028.77 1189.16 4003 1293.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "mur_fond",
    "data-name": "mur fond",
    className: "cls-35",
    points: "7500 1412.36 3780.21 1412.36 3779.08 1192.02 3789.19 1192.02 3789.19 259.94 7500 259.94 7500 1412.36"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 4656.06,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1559.25h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1541.58h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1523h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1505.3h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1488h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1470.28h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1451.67h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1434h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1415.92h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1398.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1379.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1362h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1344.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1326.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1308.33h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1290.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1272.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1255h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1236.38h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1218.7h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1201.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1183.69h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1165.07h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1147.4h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1129.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1111.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1093h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1075.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1058h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1040.35h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1021.74h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,1004.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,981.91h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,964.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,945.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,928h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,910.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,892.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,874.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,856.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,838.57h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,820.9h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,802.29h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,784.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,767.27h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,749.6h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,731h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,713.31h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,695.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,677.64h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,659h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,641.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,624h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,606.34h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,587.73h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,570.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4660.93,552h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 3808.08,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1563.2h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1545.53h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1526.91h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1509.24h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1491.9h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1474.22h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1455.61h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1437.94h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1419.86h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1402.19h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1383.58h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1365.9h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1348.56h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1330.89h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1312.27h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1294.6h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1276.61h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1258.93h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1240.32h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1222.65h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1205.3h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1187.63h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1169h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1151.35h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1133.27h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1115.59h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1097h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1079.31h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1062h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1044.29h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1025.68h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,1008h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,985.86h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,968.18h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,949.57h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,931.9h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,914.55h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,896.88h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,878.27h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,860.6h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,842.52h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,824.84h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,806.23h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,788.56h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,771.22h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,753.54h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,734.93h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,717.26h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,699.26h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,681.59h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,663h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,645.3h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,628h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,610.29h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,591.68h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,574h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M3811.13,555.93h6.3v-7a3.15,3.15,0,1,0-6.3,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 4627.29,
    y: 259.94,
    width: 16.56,
    height: 965.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 4603.06,
    y: 259.94,
    width: 16.56,
    height: 965.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 6059.29,
    y: 259.94,
    width: 16.56,
    height: 964.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 7458.29,
    y: 259.94,
    width: 16.56,
    height: 964.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 6036.06,
    y: 259.94,
    width: 16.56,
    height: 964.76
  }), /*#__PURE__*/React.createElement("g", {
    id: "arri\\xE8re"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "5623.53 770.82 5629.06 770.82 6034.96 770.82 6034.96 745.73 6054.32 745.73 6054.32 843.46 6034.96 843.46 6034.96 800.75 5629.06 800.75 5623.53 800.75 4983.08 800.75 4983.08 770.82 5623.53 770.82"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 4680.29,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1559.25h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1541.58h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1523h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1505.3h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1488h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1470.28h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1451.67h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1434h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1415.92h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1398.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1379.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1362h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1344.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1326.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1308.33h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1290.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1272.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1255h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1236.38h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1218.7h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1201.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1183.69h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1165.07h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1147.4h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1129.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1111.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1093h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1075.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1058h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1040.35h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1021.74h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,1004.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,981.91h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,964.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,945.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,928h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,910.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,892.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,874.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,856.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,838.57h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,820.9h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,802.29h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,784.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,767.27h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,749.6h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,731h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,713.31h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,695.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,677.64h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,659h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,641.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,624h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,606.34h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,587.73h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,570.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M4685.16,552h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "4602.65 770.82 4234.86 770.82 4229.34 770.82 3823.43 770.82 3823.43 745.73 3804.08 745.73 3804.08 843.46 3823.43 843.46 3823.43 800.75 4229.34 800.75 4234.86 800.75 4602.65 800.75 4602.65 843.46 4622.01 843.46 4622.01 745.73 4602.65 745.73 4602.65 770.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "5056.55 770.82 5051.02 770.82 4645.12 770.82 4645.12 745.73 4625.77 745.73 4625.77 843.46 4645.12 843.46 4645.12 800.75 5051.02 800.75 5056.55 800.75 5697 800.75 5697 770.82 5056.55 770.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "4602.65 329.82 4234.86 329.82 4229.34 329.82 3823.43 329.82 3823.43 304.73 3804.08 304.73 3804.08 402.46 3823.43 402.46 3823.43 359.75 4229.34 359.75 4234.86 359.75 4602.65 359.75 4602.65 402.46 4622.01 402.46 4622.01 304.73 4602.65 304.73 4602.65 329.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "5056.55 329.82 5051.02 329.82 4645.12 329.82 4645.12 304.73 4625.77 304.73 4625.77 402.46 4645.12 402.46 4645.12 359.75 5051.02 359.75 5056.55 359.75 5697 359.75 5697 329.82 5056.55 329.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "6034.65 329.82 5666.86 329.82 5661.34 329.82 5255.44 329.82 5255.44 359.75 5661.34 359.75 5666.86 359.75 6034.65 359.75 6034.65 402.46 6054.01 402.46 6054.01 304.73 6034.65 304.73 6034.65 329.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "6488.55 329.82 6483.02 329.82 6077.12 329.82 6077.12 304.73 6057.77 304.73 6057.77 402.46 6077.12 402.46 6077.12 359.75 6483.02 359.75 6488.55 359.75 7129 359.75 7129 329.82 6488.55 329.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "7457.65 329.82 7089.86 329.82 7084.34 329.82 6678.44 329.82 6678.44 359.75 7084.34 359.75 7089.86 359.75 7457.65 359.75 7457.65 402.46 7477.01 402.46 7477.01 304.73 7457.65 304.73 7457.65 329.82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deva"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5082.69,
    y: 781.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "4696.69 756.54 4696.69 781.63 5087.95 781.63 5087.95 811.56 4696.69 811.56 4696.69 854.28 4678.29 854.28 4678.29 756.54 4696.69 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,1044h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,1064.06h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,1082.5h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,1100.17h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,1116.79h-4V1109c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "4653.7 756.54 4653.7 781.63 4256.52 781.63 4256.52 811.56 4653.7 811.56 4653.7 854.28 4674.29 854.28 4674.29 756.54 4653.7 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4662.74,1044h4.48v-7.78a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4662.74,1064.06h4.48v-7.79a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4662.74,1082.5h4.48v-7.79a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4662.74,1100.17h4.48v-7.78a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4662.74,1116.79h4.48V1109a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "3824.67 756.54 3824.67 781.63 4262.4 781.63 4262.4 811.56 3824.67 811.56 3824.67 854.28 3804.08 854.28 3804.08 756.54 3824.67 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,1044h-4.48v-7.78a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,1064.06h-4.48v-7.79a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,1082.5h-4.48v-7.79a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,1100.17h-4.48v-7.78a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,1116.79h-4.48V1109a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "3750.46 1413.61 3750.46 460.28 3789 458.54 3789 1413.61 3750.46 1413.61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 6086.23,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1559.25h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1541.58h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1523h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1505.3h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1488h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1470.28h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1451.67h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1434h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1415.92h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1398.24h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1379.63h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1362h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1344.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1326.94h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1308.33h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1290.66h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1272.66h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1255h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1236.38h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1218.7h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1201.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1183.69h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1165.07h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1147.4h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1129.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1111.65h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1093h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1075.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1058h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1040.35h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1021.74h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,1004.06h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,981.91h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,964.24h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,945.63h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,928h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,910.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,892.94h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,874.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,856.65h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,838.57h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,820.9h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,802.29h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,784.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,767.27h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,749.6h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,731h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,713.31h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,695.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,677.64h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,659h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,641.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,624h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,606.34h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,587.73h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,570.06h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6097.92,552h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5086.08,
    y: 781.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "6086.39 756.54 6086.39 781.63 5695.13 781.63 5695.13 811.56 6086.39 811.56 6086.39 854.28 6104.79 854.28 6104.79 756.54 6086.39 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,1044h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,1064.06h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,1082.5h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,1100.17h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,1116.79h4V1109c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deva-2",
    "data-name": "deva"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5082.69,
    y: 318.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "4696.69 293.54 4696.69 318.63 5087.95 318.63 5087.95 348.56 4696.69 348.56 4696.69 391.28 4678.29 391.28 4678.29 293.54 4696.69 293.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,581h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,601.06h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,619.5h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,637.17h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4688.62,653.79h-4V646c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 5086.08,
    y: 318.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "6086.39 293.54 6086.39 318.63 5695.13 318.63 5695.13 348.56 6086.39 348.56 6086.39 391.28 6104.79 391.28 6104.79 293.54 6086.39 293.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,581h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,601.06h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,619.5h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,637.17h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6094.47,653.79h4V646c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 6112.29,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1559.25h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1541.58h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1523h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1505.3h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1488h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1470.28h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1451.67h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1434h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1415.92h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1398.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1379.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1362h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1344.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1326.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1308.33h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1290.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1272.66h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1255h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1236.38h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1218.7h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1201.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1183.69h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1165.07h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1147.4h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1129.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1111.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1093h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1075.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1058h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1040.35h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1021.74h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,1004.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,981.91h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,964.24h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,945.63h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,928h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,910.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,892.94h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,874.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,856.65h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,838.57h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,820.9h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,802.29h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,784.61h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,767.27h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,749.6h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,731h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,713.31h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,695.32h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,677.64h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,659h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,641.36h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,624h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,606.34h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,587.73h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,570.06h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M6117.16,552h6.29v-7a3.15,3.15,0,1,0-6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deva-3",
    "data-name": "deva"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6514.69,
    y: 781.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "6128.69 756.54 6128.69 781.63 6519.95 781.63 6519.95 811.56 6128.69 811.56 6128.69 854.28 6110.29 854.28 6110.29 756.54 6128.69 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,1044h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,1064.06h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,1082.5h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,1100.17h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,1116.79h-4V1109c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 7473.23,
    y: 259.94,
    width: 16.56,
    height: 1032.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1559.25h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1541.58h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1523h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1505.3h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1488h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1470.28h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1451.67h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1434h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1415.92h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1398.24h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1379.63h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1362h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1344.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1326.94h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1308.33h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1290.66h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1272.66h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1255h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1236.38h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1218.7h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1201.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1183.69h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1165.07h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1147.4h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1129.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1111.65h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1093h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1075.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1058h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1040.35h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1021.74h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,1004.06h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,981.91h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,964.24h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,945.63h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,928h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,910.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,892.94h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,874.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,856.65h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,838.57h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,820.9h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,802.29h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,784.61h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,767.27h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,749.6h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,731h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,713.31h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,695.32h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,677.64h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,659h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,641.36h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,624h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,606.34h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,587.73h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,570.06h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M7484.92,552h-6.29v-7a3.15,3.15,0,1,1,6.29,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6485.08,
    y: 781.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "7472.39 756.54 7472.39 781.63 7081.13 781.63 7081.13 811.56 7472.39 811.56 7472.39 854.28 7490.79 854.28 7490.79 756.54 7472.39 756.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,1044h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,1064.06h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,1082.5h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,1100.17h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,1116.79h4V1109c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "deva-4",
    "data-name": "deva"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6514.69,
    y: 317.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "6128.69 292.54 6128.69 317.63 6519.95 317.63 6519.95 347.56 6128.69 347.56 6128.69 390.28 6110.29 390.28 6110.29 292.54 6128.69 292.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,580h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,600.06h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,618.5h-4v-7.79c0-3.31,4-3.31,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,636.17h-4v-7.78c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M6120.62,652.79h-4V645c0-3.32,4-3.32,4,0Z",
    transform: "translate(0 -271.3)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 6485.08,
    y: 317.63,
    width: 614.31,
    height: 29.93
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "7472.39 292.54 7472.39 317.63 7081.13 317.63 7081.13 347.56 7472.39 347.56 7472.39 390.28 7490.79 390.28 7490.79 292.54 7472.39 292.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,580h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,600.06h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,618.5h4v-7.79c0-3.31-4-3.31-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,636.17h4v-7.78c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M7480.47,652.79h4V645c0-3.32-4-3.32-4,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "devant"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "4654.7 292.67 4654.7 317.76 4257.52 317.76 4257.52 347.69 4654.7 347.69 4654.7 390.41 4675.29 390.41 4675.29 292.67 4654.7 292.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4663.74,580.17h4.48v-7.78a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4663.74,600.19h4.48V592.4a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4663.74,618.63h4.48v-7.79a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4663.74,636.3h4.48v-7.78a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M4663.74,652.92h4.48v-7.79a2.25,2.25,0,1,0-4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "3825.67 292.67 3825.67 317.76 4263.4 317.76 4263.4 347.69 3825.67 347.69 3825.67 390.41 3808 390.7 3808 292.7 3825.67 292.67"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,580.17h-4.48v-7.78a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,600.19h-4.48V592.4a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,618.63h-4.48v-7.79a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,636.3h-4.48v-7.78a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M3816.63,652.92h-4.48v-7.79a2.25,2.25,0,1,1,4.48,0Z",
    transform: "translate(0 -271.3)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "cartons"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "5933.76 1242.22 5927.91 1237.41 5632.1 1150.21 5600.02 1150.43 5613.74 1209.58 5634.21 1242.66 5636 1279.92 5645.46 1297.04 5643.6 1240.82 5740.95 1261.55 5764 1295.23 5806.19 1254.1 5869 1261.5 5897.06 1297.04 5933.76 1242.22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "5932.44 1297.04 5933.76 1242.22 5643.6 1240.82 5645.46 1297.04 5682.86 1297.04 5681.93 1261.27 5763.94 1261.73 5763.94 1297.04 5813.65 1297.04 5815.28 1261.5 5897.52 1261.5 5897.06 1297.04 5932.44 1297.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5869,
    y: 1517.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11752.97 2768.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5816.85,
    y: 1517.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11648.67 2768.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5748.37,
    y: 1517.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11511.71 2768.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5696.22,
    y: 1517.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11407.41 2768.92) rotate(-180)"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "5931.65 1237.86 5931.65 1169.52 5927.2 1165.66 5927.2 1099.4 5900.16 1080.98 5628.58 1083.65 5628.58 1216.17 5644.18 1238.62 5931.65 1237.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "5927.2 1165.66 5643.6 1170.22 5628.58 1150.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 5788.68,
    y1: 1238.24,
    x2: 5788.54,
    y2: 1167.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "5785.4 1167.94 5785.4 1102.07 5763.34 1082.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "5621.76 1243.7 5615.91 1238.9 5319.1 1151.7 5287.02 1151.92 5300 1220.7 5321.21 1244.14 5323 1281.41 5333.46 1298.53 5331.6 1242.31 5427.95 1263.04 5451 1297.72 5493.19 1255.59 5556 1262.99 5584.06 1298.53 5621.76 1243.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-2",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "5619.86 1298.04 5621.18 1243.22 5331.02 1241.82 5332.88 1298.04 5370.28 1298.04 5369.35 1262.27 5451.36 1262.73 5451.36 1298.04 5501.07 1298.04 5502.7 1262.5 5584.94 1262.5 5584.48 1298.04 5619.86 1298.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5556.42,
    y: 1518.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11127.81 2770.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5504.27,
    y: 1518.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(11023.51 2770.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5435.79,
    y: 1518.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(10886.55 2770.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5383.64,
    y: 1518.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(10782.25 2770.92) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M5617.21,1513.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6L5436,1261v10.57l-132,.43,2,216,25,25.12Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "5476.1 1241.82 5476.1 1171.22 5473.31 1165 5473.31 1167.51 5331.02 1167.05 5331.02 1170.02 5473.77 1170.25 5473.31 1241.82 5476.1 1241.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 5473.59,
    y: 1146.14,
    width: 130.75,
    height: 2.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "5604.34 1080.1 5473.59 1081.04 5473.59 1077.28 5604.34 1077.28 5604.34 1080.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "5470.59 1098.81 5470.59 1097 5331.02 1095.94 5331.02 1098.81 5470.59 1098.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "5605 1013.7 5460 1013.7 5474 1029.7 5329 1026.7 5304 1000.7 5449 999.7 5436 989.7 5580.89 989.58 5605 1013.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "5331 1241.7 5334 1029.7 5304 1000.7 5306 1216.7 5331 1241.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "5604.34 1013.18 5460 1013.7 5473.99 1029.46 5473.59 1148.43 5604 1147.7 5604.34 1013.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "6769.76 1239.7 6763.91 1234.9 6467.1 1147.7 6435.02 1147.92 6440 1207.7 6469.21 1240.14 6471 1277.41 6481.46 1294.53 6479.6 1238.31 6575.95 1259.04 6599 1293.72 6641.19 1251.59 6704 1258.99 6732.06 1294.53 6769.76 1239.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-3",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "6767.86 1294.04 6769.18 1239.22 6479.02 1237.82 6480.88 1294.04 6518.28 1294.04 6517.35 1258.27 6599.36 1258.73 6599.36 1294.04 6649.07 1294.04 6650.7 1258.5 6732.94 1258.5 6732.48 1294.04 6767.86 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6704.42,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(13423.81 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6652.27,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(13319.51 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6583.79,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(13182.55 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6531.64,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(13078.25 2762.92) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M6765.21,1509.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6L6584,1257v10.57l-132,.43,2,216,25,25.12Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "6624.1 1237.82 6624.1 1167.22 6621.31 1161 6621.31 1163.51 6479.02 1163.05 6479.02 1166.02 6621.77 1166.25 6621.31 1237.82 6624.1 1237.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 6621.59,
    y: 1142.14,
    width: 130.75,
    height: 2.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "6752.34 1076.1 6621.59 1077.04 6621.59 1073.28 6752.34 1073.28 6752.34 1076.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "6618.59 1094.81 6618.59 1093 6479.02 1091.94 6479.02 1094.81 6618.59 1094.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "6753 1009.7 6608 1009.7 6622 1025.7 6477 1022.7 6452 996.7 6597 995.7 6584 985.7 6728.89 985.58 6753 1009.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "6479 1237.7 6482 1025.7 6452 996.7 6454 1212.7 6479 1237.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "6752.34 1009.18 6608 1009.7 6621.99 1025.46 6621.59 1144.43 6752 1143.7 6752.34 1009.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "7417.76 1239.7 7411.91 1234.9 7115.1 1147.7 7081 1147.7 7080 1198.7 7117.21 1240.14 7119 1277.41 7129.46 1294.53 7127.6 1238.31 7223.95 1259.04 7247 1293.72 7289.19 1251.59 7352 1258.99 7380.06 1294.53 7417.76 1239.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-4",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "7415.86 1294.04 7417.18 1239.22 7127.02 1237.82 7128.88 1294.04 7166.28 1294.04 7165.35 1258.27 7247.36 1258.73 7247.36 1294.04 7297.07 1294.04 7298.7 1258.5 7380.94 1258.5 7380.48 1294.04 7415.86 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 7352.42,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(14719.81 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 7300.27,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(14615.51 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 7231.79,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(14478.55 2762.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 7179.64,
    y: 1514.28,
    width: 14.97,
    height: 5.67,
    transform: "translate(14374.25 2762.92) rotate(-180)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M7413.21,1509.12l1.84-67.63-14.71-25.76a4,4,0,0,1,0-2.29v-66a2.53,2.53,0,0,1,0-2.82v-64.1l-23.45-23.6L7232,1257v10.57l-132,.43v60l-18-1-1,102,46,80.12Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "7272.1 1237.82 7272.1 1167.22 7269.31 1161 7269.31 1163.51 7127.02 1163.05 7127.02 1166.02 7269.77 1166.25 7269.31 1237.82 7272.1 1237.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 7269.59,
    y: 1142.14,
    width: 130.75,
    height: 2.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "7400.34 1076.1 7269.59 1077.04 7269.59 1073.28 7400.34 1073.28 7400.34 1076.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "7266.59 1094.81 7266.59 1093 7127.02 1091.94 7127.02 1094.81 7266.59 1094.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "7401 1009.7 7256 1009.7 7270 1025.7 7125 1022.7 7100 996.7 7245 995.7 7232 985.7 7376.89 985.58 7401 1009.7"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "7127 1237.7 7130 1025.7 7100 996.7 7100 1071.7 7082 1055.7 7080 1180.7 7127 1237.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "7400.34 1009.18 7256 1009.7 7269.99 1025.46 7269.59 1144.43 7400 1143.7 7400.34 1009.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "5311 1237.7 5298 1227.7 5015.1 1147.7 4983.02 1147.92 4996 1216.7 5017.21 1240.14 5019 1277.41 5029.46 1294.53 5028 1239.7 5123.95 1259.04 5145 1293.7 5189.19 1251.59 5245 1258.99 5273.06 1294.53 5311 1237.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-5",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "5029 1294.04 5027.7 1239.22 5311.06 1237.82 5309.25 1294.04 5272.72 1294.04 5273.63 1258.27 5193.55 1258.73 5193.55 1294.04 5145 1294.04 5143.41 1258.5 5063.1 1258.5 5063.55 1294.04 5029 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5076.33,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5127.26,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5194.13,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5245.06,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "5026.13 1237.27 4995.08 1198.98 5000.55 888.69 4950.73 869.32 4950.73 862.41 4995.73 862.41 4996.11 816.65 5107.85 816.65 5151.32 820.13 5152.85 862.41 5190.98 862.41 5302.71 888.38 5305.78 1233.99 5026.13 1237.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "5026.13 1237.27 5023.64 893.77 5015.99 888.69 5015.99 821.74 4996.11 816.65 4995.73 862.41 4997.72 883.6 4950.73 862.41 4950.73 869.32 4997.72 888.69 4995.08 1198.98 5026.13 1237.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M5165.51,1506.94h2.55v-67.15l-1.28-2.54V1372l-.86-2.29.86-66.82L5304,1301l0-2-136.12.94.22-67.26,132.36-1.42s1.07-2,.53-2.14-134,1.25-134,1.25v-68.5l-11.56-3.57v2.15l10,5.34-.36,66-140.88,1.78v2.13l141.24-.71-.36,66.18-140.38,2.32h139.41v66.18l1,2.85-1,66.36,1.69,1.78Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M4997.72,1215.62c4.9,2.74,26.41,17.13,26.41,17.13v3l-26.42-17.83Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "5024.64 1030.91 4996.68 1010.29 4996.68 1012.12 5024.64 1032.19 5024.64 1030.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "5025.13 1099.41 4996.12 1076.89 4996.12 1078.74 5025.14 1100.98 5025.13 1099.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "5164.05 1098.36 5025.13 1099.41 5025.14 1100.98 5165.02 1101.21 5164.05 1098.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "5166.78 1100.66 5165.92 1098.37 5304.56 1096.48 5304.58 1098.36 5166.78 1100.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "5168.06 1168.49 5305.18 1165.97 5304.58 1164.17 5166.78 1165.95 5168.06 1168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "5164.05 1166.33 5025.62 1167.18 5025.63 1168.49 5165.02 1168.49 5164.05 1166.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "5015.99 888.69 5153.13 887.73 5155.42 889.15 5155.42 887 5153.16 885.96 5015.99 888.41 5015.99 888.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "4997.72 883.6 4950.73 862.41 4995.73 862.41 4997.72 883.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "5302.71 888.38 5166.98 890.57 5153.16 885.96 5152.85 862.41 5190.65 862.32 5302.71 888.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "6446 1237.7 6433 1227.7 6150.1 1147.7 6129 1147.7 6129 1214.7 6152.21 1240.14 6154 1277.41 6164.46 1294.53 6163 1239.7 6258.95 1259.04 6280 1293.7 6324.19 1251.59 6380 1258.99 6408.06 1294.53 6446 1237.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-6",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "6164 1294.04 6162.7 1239.22 6446.06 1237.82 6444.25 1294.04 6407.72 1294.04 6408.63 1258.27 6328.55 1258.73 6328.55 1294.04 6280 1294.04 6278.41 1258.5 6198.1 1258.5 6198.55 1294.04 6164 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6211.33,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6262.26,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6329.13,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6380.06,
    y: 1242.98,
    width: 14.61,
    height: 5.67
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "6161.13 1237.27 6130.08 1198.98 6135.55 888.69 6130.73 862.41 6129 816.7 6242.85 816.65 6286.32 820.13 6287.85 862.41 6325.98 862.41 6437.71 888.38 6440.78 1233.99 6161.13 1237.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "6160.13 1235.27 6157.64 891.77 6149.99 886.69 6149.99 819.74 6129 816.7 6129.08 1196.98 6160.13 1235.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M6300.51,1506.94h2.55v-67.15l-1.28-2.54V1372l-.86-2.29.86-66.82L6439,1301l0-2-136.12.94.22-67.26,132.36-1.42s1.07-2,.53-2.14-134,1.25-134,1.25v-68.5l-11.56-3.57v2.15l10,5.34-.36,66-140.88,1.78v2.13l141.24-.71-.36,66.18-140.38,2.32h139.41v66.18l1,2.85-1,66.36,1.69,1.78Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M6132.72,1215.62c4.9,2.74,26.41,17.13,26.41,17.13v3l-26.42-17.83Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "6159.64 1030.91 6131.68 1010.29 6131.68 1012.12 6159.64 1032.19 6159.64 1030.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "6160.13 1099.41 6131.12 1076.89 6131.12 1078.74 6160.14 1100.98 6160.13 1099.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "6299.05 1098.36 6160.13 1099.41 6160.14 1100.98 6300.02 1101.21 6299.05 1098.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "6301.78 1100.66 6300.92 1098.37 6439.56 1096.48 6439.58 1098.36 6301.78 1100.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "6303.06 1168.49 6440.18 1165.97 6439.58 1164.17 6301.78 1165.95 6303.06 1168.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "6299.05 1166.33 6160.62 1167.18 6160.63 1168.49 6300.02 1168.49 6299.05 1166.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "6150.99 888.69 6288.13 887.73 6290.42 889.15 6290.42 887 6288.16 885.96 6150.99 888.41 6150.99 888.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "6437.71 888.38 6301.98 890.57 6288.16 885.96 6287.85 862.41 6325.65 862.32 6437.71 888.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M4998.22,1508.4l-12.22-9.28a1,1,0,0,0-.35-.17l-286-79.91a.9.9,0,0,0-.28,0H4698a1,1,0,0,0-1,1v83.66a1,1,0,0,0,.16.55l4.3,7a1,1,0,0,1,.16.49l1.79,36.77a1.16,1.16,0,0,0,.12.44l6.55,12.43a1,1,0,0,0,2-.47l.48-48.62a1,1,0,0,1,1.24-1l95.45,19a1.05,1.05,0,0,1,.69.47l20.43,33.19a1,1,0,0,0,1.6.21l43.41-40.89a1,1,0,0,1,.85-.28l55.59,7.28a1.06,1.06,0,0,1,.68.38l27.25,34.12a1,1,0,0,0,1.67-.07l37.07-54.84A1.05,1.05,0,0,0,4998.22,1508.4Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-7",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M4711.69,1564.33l-1.28-52.75a1.05,1.05,0,0,1,1-1.07l288-1.38a1,1,0,0,1,1,1.07l-1.78,54.14a1,1,0,0,1-1,1h-35.32a1,1,0,0,1-1-1.06l.87-33.64a1,1,0,0,0-1-1.07l-79.89.46a1,1,0,0,0-1,1v33.23a1,1,0,0,1-1,1h-47.68a1,1,0,0,1-1-1l-1.53-33.56a1,1,0,0,0-1-1h-80.2a1,1,0,0,0-1,1l.44,33.44a1,1,0,0,1-1,1h-33.31A1,1,0,0,1,4711.69,1564.33Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4760.18,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4812.33,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4880.81,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4932.96,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M4697,1488.2l13.08,21.81a1,1,0,0,0,.9.5l282.39-1.35a1.05,1.05,0,0,0,1-1l6.13-347.42a1,1,0,0,0-.67-1l-66.73-25.94a.94.94,0,0,0-.37-.07H4697.89a1,1,0,0,0-1,1v352.91A1,1,0,0,0,4697,1488.2Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M4708.23,1503.17v-60.65a1,1,0,0,1,1-1l133.92-1.85H4712.82a1,1,0,0,1-1-1l-.42-64.28a1,1,0,0,1,1-1l139.75-1.52s1.31-1.31,0-1.31H4711.29a1,1,0,0,1-1-1l-.21-65.56a1.05,1.05,0,0,1,.52-.91l.93-.52a1.06,1.06,0,0,0,.52-.88l1.51-67.6a1.07,1.07,0,0,0-.19-.63l-4.95-6.91a1,1,0,0,1-.19-.44l-.87-5.53a1,1,0,0,1,.63-1.12l.81-.35a1,1,0,0,0,.63-.93l1.29-60.75a1,1,0,0,0-.14-.56L4698.78,1137a1,1,0,0,0-1.93.54v350.16a1,1,0,0,0,.15.54l9.3,15.5A1,1,0,0,0,4708.23,1503.17Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M4851,1508.57h.63a1,1,0,0,0,1-1v-66.11a1,1,0,0,1,1-1h138a1,1,0,0,0,1.05-1h0a1,1,0,0,0-1-1l-135.94-.18a1.05,1.05,0,0,1-1-1l-.31-65.1a1,1,0,0,1,1.05-1H4993a1,1,0,0,0,.9-1.56l-.18-.31a1,1,0,0,0-.9-.51h-137.3a1,1,0,0,1-1-1V1302.6a1,1,0,0,1,1-1l136.66-.79a1,1,0,0,0,.93-.59l.2-.42a1,1,0,0,0-.95-1.49l-135.23.9a1,1,0,0,1-1-1V1232a1,1,0,0,1,1-1l137.44-1a1,1,0,0,0,.51-.14c.83-.47,3.53-2,2.34-2s-124.89,1.25-137.5,1.38a1,1,0,0,1-1.05-1l-.58-66.17a1,1,0,0,0-.74-1l-11.29-3.37a1,1,0,0,0-1.34,1l-2.23,60.85a1,1,0,0,0,.23.69l10.68,13.35a1.05,1.05,0,0,1,.23.65l-.31,65.63a1,1,0,0,1-.08.39l-.47,1.15a1,1,0,0,1-1,.65l-139.74.17a1,1,0,0,0-.51.13l-1.72,1v.85l140.32.42a1,1,0,0,1,1,1l.73,64.9.57,67.82a1,1,0,0,1-1,1l-1,0a1,1,0,0,0-1,1l.36,67.17A1,1,0,0,0,4851,1508.57Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M4711.09,1219l131.23,1.12a1,1,0,0,0,1.05-1l2.21-60.5a1,1,0,0,0-1-1.08l-132.18-.27a1.05,1.05,0,0,0-1.05,1l-1.26,59.65A1,1,0,0,0,4711.09,1219Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M7083.22,1508.4l-12.22-9.28a1,1,0,0,0-.35-.17l-286-79.91a.9.9,0,0,0-.28,0H6783a1,1,0,0,0-1,1v45h-16v32h8v-7l12.46,21.22a1,1,0,0,1,.16.49l1.79,36.77a1.16,1.16,0,0,0,.12.44l6.55,12.43a1,1,0,0,0,2-.47l.48-48.62a1,1,0,0,1,1.24-1l95.45,19a1.05,1.05,0,0,1,.69.47l20.43,33.19a1,1,0,0,0,1.6.21l43.41-40.89a1,1,0,0,1,.85-.28l55.59,7.28a1.06,1.06,0,0,1,.68.38l27.25,34.12a1,1,0,0,0,1.67-.07l37.07-54.84A1.05,1.05,0,0,0,7083.22,1508.4Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-8",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M6796.69,1564.33l-1.28-52.75a1.05,1.05,0,0,1,1-1.07l288-1.38a1,1,0,0,1,1,1.07l-1.78,54.14a1,1,0,0,1-1,1h-35.32a1,1,0,0,1-1-1.06l.87-33.64a1,1,0,0,0-1-1.07l-79.89.46a1,1,0,0,0-1,1v33.23a1,1,0,0,1-1,1h-47.68a1,1,0,0,1-1-1l-1.53-33.56a1,1,0,0,0-1-1h-80.2a1,1,0,0,0-1,1l.44,33.44a1,1,0,0,1-1,1h-33.31A1,1,0,0,1,6796.69,1564.33Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6845.18,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6897.33,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 6965.81,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 7017.96,
    y: 1242.98,
    width: 14.97,
    height: 5.67,
    rx: 1.04
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "6782 1216.7 6766 1193.7 6767 933.7 6781.85 933.7 6782 1216.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M6782,1488.2l13.08,21.81a1,1,0,0,0,.9.5l282.39-1.35a1.05,1.05,0,0,0,1-1l6.13-347.42a1,1,0,0,0-.67-1l-66.73-25.94a.94.94,0,0,0-.37-.07H6782.89a1,1,0,0,0-1,1v352.91A1,1,0,0,0,6782,1488.2Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M6793.23,1503.17v-60.65a1,1,0,0,1,1-1l133.92-1.85H6797.82a1,1,0,0,1-1-1l-.42-64.28a1,1,0,0,1,1-1l139.75-1.52s1.31-1.31,0-1.31H6796.29a1,1,0,0,1-1-1l-.21-65.56a1.05,1.05,0,0,1,.52-.91l.93-.52a1.06,1.06,0,0,0,.52-.88l1.51-67.6a1.07,1.07,0,0,0-.19-.63l-4.95-6.91a1,1,0,0,1-.19-.44l-.87-5.53a1,1,0,0,1,.63-1.12l.81-.35a1,1,0,0,0,.63-.93l1.29-60.75a1,1,0,0,0-.14-.56L6783.78,1137a1,1,0,0,0-1.93.54l.15,81.5-15-14-1,260,15.85,22.66a1,1,0,0,0,.15.54l9.3,15.5A1,1,0,0,0,6793.23,1503.17Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M6936,1508.57h.63a1,1,0,0,0,1-1v-66.11a1,1,0,0,1,1-1h138a1,1,0,0,0,1.05-1h0a1,1,0,0,0-1-1l-135.94-.18a1.05,1.05,0,0,1-1-1l-.31-65.1a1,1,0,0,1,1.05-1H7078a1,1,0,0,0,.9-1.56l-.18-.31a1,1,0,0,0-.9-.51h-137.3a1,1,0,0,1-1-1V1302.6a1,1,0,0,1,1-1l136.66-.79a1,1,0,0,0,.93-.59l.2-.42a1,1,0,0,0-.95-1.49l-135.23.9a1,1,0,0,1-1-1V1232a1,1,0,0,1,1-1l137.44-1a1,1,0,0,0,.51-.14c.83-.47,3.53-2,2.34-2s-124.89,1.25-137.5,1.38a1,1,0,0,1-1.05-1l-.58-66.17a1,1,0,0,0-.74-1l-11.29-3.37a1,1,0,0,0-1.34,1l-2.23,60.85a1,1,0,0,0,.23.69l10.68,13.35a1.05,1.05,0,0,1,.23.65l-.31,65.63a1,1,0,0,1-.08.39l-.47,1.15a1,1,0,0,1-1,.65l-139.74.17a1,1,0,0,0-.51.13l-1.72,1v.85l140.32.42a1,1,0,0,1,1,1l.73,64.9.57,67.82a1,1,0,0,1-1,1l-1,0a1,1,0,0,0-1,1l.36,67.17A1,1,0,0,0,6936,1508.57Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M6796.09,1219l131.23,1.12a1,1,0,0,0,1.05-1l2.21-60.5a1,1,0,0,0-1-1.08l-132.18-.27a1.05,1.05,0,0,0-1.05,1l-1.26,59.65A1,1,0,0,0,6796.09,1219Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "4028.02 1239.22 4033.88 1234.41 4329.68 1147.21 4361.76 1147.43 4348.04 1206.58 4327.57 1239.66 4325.78 1276.92 4316.32 1294.04 4318.18 1237.82 4220.83 1258.55 4197.78 1292.23 4155.59 1251.1 4092.78 1258.5 4064.72 1294.04 4028.02 1239.22"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-9",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "4029.34 1294.04 4028.02 1239.22 4318.18 1237.82 4316.32 1294.04 4278.92 1294.04 4279.85 1258.27 4197.84 1258.73 4197.84 1294.04 4148.13 1294.04 4146.5 1258.5 4064.26 1258.5 4064.72 1294.04 4029.34 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4077.81,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4129.96,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4198.44,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4250.59,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "4030.13 1234.86 4030.13 1166.52 4034.58 1162.66 4034.58 1096.4 4061.62 1077.98 4333.2 1080.65 4333.2 1213.17 4317.6 1235.62 4030.13 1234.86"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "4034.58 1162.66 4318.18 1167.22 4333.2 1147.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-47",
    x1: 4173.1,
    y1: 1235.24,
    x2: 4173.24,
    y2: 1164.94
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-47",
    points: "4176.38 1164.94 4176.38 1099.07 4198.44 1079.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "4345.02 1239.7 4350.88 1234.9 4541 1152.7 4591 1157.7 4625 1202.7 4628 1234.7 4588 1258.7 4595 1294.7 4635.18 1238.31 4521 1258.7 4514.78 1292.72 4472.59 1251.59 4395 1258.7 4381.73 1294.53 4345.02 1239.7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-10",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "4346.24 1294.04 4344.92 1239.22 4635.08 1237.82 4633.22 1294.04 4595.82 1294.04 4596.75 1258.27 4514.74 1258.73 4514.74 1294.04 4465.03 1294.04 4463.4 1258.5 4381.16 1258.5 4381.63 1294.04 4346.24 1294.04"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4394.71,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4446.86,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4515.34,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4567.49,
    y: 1242.98,
    width: 14.97,
    height: 5.67
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-77"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M4348.89,1509.12l-1.84-67.63,14.71-22.75v-3a4,4,0,0,0,0-2.29v-66a2.53,2.53,0,0,0,0-2.82v-64.1l23.45-23.6H4508v10.69h125.07l2,26.55v215Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "4490 1237.82 4490 1167.22 4492.79 1161 4492.79 1163.51 4635.08 1163.05 4635.08 1166.02 4492.33 1166.25 4492.79 1237.82 4490 1237.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 4361.76,
    y: 1142.14,
    width: 130.75,
    height: 2.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "4361.76 1076.1 4492.51 1077.04 4492.51 1073.28 4361.76 1073.28 4361.76 1076.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "4495.51 1094.81 4495.51 1093 4635.08 1091.94 4635.08 1094.81 4495.51 1094.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "4340.74 1028.59 4645.85 1022.99 4633.3 985.58 4385.21 985.58 4340.74 1028.59"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "4270.9 782.32 4308.28 771.26 4309.37 746.77 4404.02 747.01 4404.02 782.32 4418.25 771.81 4418.25 746.93 4269.89 746.04 4270.9 782.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "4273.68 746.69 4273.68 778.32 4288.84 774.27 4288.84 746.77 4273.68 746.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "4292.11 746.82 4292.11 772.83 4304 769.17 4304.52 746.82 4292.11 746.82"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-11",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "4235.52 782.32 4234.19 727.49 4524.35 726.1 4522.5 782.32 4485.09 782.32 4486.02 746.54 4404.02 747.01 4404.02 782.32 4354.3 782.32 4352.67 746.77 4270.44 746.77 4270.9 782.32 4235.52 782.32"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4283.99,
    y: 731.25,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4336.14,
    y: 731.25,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4404.62,
    y: 731.25,
    width: 14.97,
    height: 5.67
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4456.77,
    y: 731.25,
    width: 14.97,
    height: 5.67
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "4234.19 727.49 4234.19 515.63 4379.27 515.63 4524.35 515.63 4522.44 726.34 4234.19 727.49"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M4379.27,854.07V786.93h1.91l.21,67.42h142.35s-2.63,3.37-2.91,3.79S4380.55,857,4380.55,857l-.56,68.25,139.86,1.12.28,2-139.3-.55-1.56,68h-2.35l1-67.42-142.72-.41,1-73.86-1,71.3H4378l.28-68.91-144.13,1v-3Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "4698.34 772.75 4711.1 781.63 4744.47 745.35 4795.96 748.3 4795.96 770.69 4829.88 781.63 4885.35 743.52 4906.49 748.37 4906.49 769.85 4960.68 781.63 4962.84 746.54 4857.01 736.4 4709.77 730.22 4698.34 730.22 4698.34 772.75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-12",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "4711.1 781.63 4709.77 730.22 4999.94 728.91 4998.08 781.63 4960.68 781.63 4961.6 748.08 4879.6 748.52 4879.6 781.63 4829.88 781.63 4828.26 748.3 4746.02 748.3 4746.48 781.63 4711.1 781.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4759.57,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4811.72,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4880.2,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 4932.35,
    y: 733.74,
    width: 14.97,
    height: 5.32
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "4698.34 730.22 4698.34 549.6 4709.77 518.21 4854.85 518.21 4999.94 518.21 4998.02 728.92 4698.34 730.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M4854.86,856.65V789.51h1.9l.21,67.42h142.35s-2.63,3.37-2.91,3.79-140.28-1.12-140.28-1.12l-.56,68.25L4995.43,929l.28,1.95-139.3-.55-1.55,68h-2.36l1-67.42-143.07-.41v70.34l-12.07.67V820.9l11.43-31.39,2,67.14-1.12,71.3h142.93l.28-68.91-142.15,1,.05-3Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "5477.34 772.75 5490.1 781.63 5523.47 745.35 5574.96 748.3 5574.96 770.69 5608.88 781.63 5664.35 743.52 5685.49 748.37 5685.49 769.85 5739.68 781.63 5741.84 746.54 5636.01 736.4 5488.77 730.22 5477.34 730.22 5477.34 772.75"
  }), /*#__PURE__*/React.createElement("g", {
    id: "caisson-13",
    "data-name": "caisson"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "5490.1 781.63 5488.77 730.22 5778.94 728.91 5777.08 781.63 5739.68 781.63 5740.6 748.08 5658.6 748.52 5658.6 781.63 5608.88 781.63 5607.26 748.3 5525.02 748.3 5525.48 781.63 5490.1 781.63"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5538.57,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5590.72,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5659.2,
    y: 733.74,
    width: 14.97,
    height: 5.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 5711.35,
    y: 733.74,
    width: 14.97,
    height: 5.32
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "5477.34 730.22 5477.34 549.6 5482 536.7 5621 534.7 5633.85 518.21 5778.94 518.21 5777.02 728.92 5477.34 730.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M5634,790l2,66.93h142.35s-2.63,3.37-2.91,3.79-140.28-1.12-140.28-1.12l-.56,68.25L5774.43,929l.28,1.95-139.3-.55-1.55,68h-2.36l1-67.42-143.07-.41v70.34l-12.07.67V820.9l4.83-13.26L5484,861l6.81-4.35-1.12,71.3h142.93l.28-68.91-142.15,1,.05-3L5621,857V806Z",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "4035.92 1094.64 4318.18 1096.53 4333.2 1080.65 4061.62 1077.98 4035.92 1094.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "4361.76 1009.18 4494.46 1009.18 4495.12 1019.84 4492.11 1025.46 4492.51 1144.43 4361.76 1147.43 4361.76 1009.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "4406.68 777.7 4410.82 774.89 4410.34 746.82 4406.68 746.86 4406.68 777.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "4413.99 772.83 4416.31 770.75 4416.31 746.94 4413.51 746.84 4413.99 772.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "4997.72 888.69 4858.29 889.93 4844.97 885.96 4710.69 885.68 4696.85 862.41 4932.96 862.41 4997.72 888.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "5030.32 820.13 4894.99 821.74 4875.07 816.65 4986.85 816.65 5030.32 820.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M5793,1510.54",
    transform: "translate(0 -271.3)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "5436 989.7 5436 999.79 5449 999.7 5436 989.7"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ombre_int\\xE9rieur",
    "data-name": "ombre int\\xE9rieur"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 3789,
    y: 259.7,
    width: 3711,
    height: 1038
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSituationSafePlace);
export default __webpack_public_path__ + "static/media/situation_safe_place.d6c1fee4480e6829f20365df2c6daa0d.svg";
export { ForwardRef as ReactComponent };